var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"container"},[_c('broker-logo')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }